import { render } from "./NewBrandTyreRangeTyres.vue?vue&type=template&id=22d53d24"
import script from "./NewBrandTyreRangeTyres.vue?vue&type=script&lang=js"
export * from "./NewBrandTyreRangeTyres.vue?vue&type=script&lang=js"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__